
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SimpleStepWizard',

  props: {
    step: { type: Number, required: true },
  },

  computed: {
    headers() {
      return Object.keys(this.$slots).filter((k) => k.startsWith('header'));
    },

    steps() {
      return Object.keys(this.$slots).filter((k) => k.startsWith('step'));
    },
  },
});
